export default __webpack_public_path__ + "static/media/AH-bulacan.002e52b0.jpg";